import { Container } from 'inversify';

import {
  BRACE_ORDERS_SERVICE,
  BraceOrdersService,
  IBraceOrdersService,
} from '@services/brace-orders.service';
import { CLIENT_SERVICE, ClientService, IClientService } from '@services/client.service';
import { CLINICS_SERVICE, ClinicsService, IClinicsService } from '@services/clinics.service';
import { FILES_SERVICE, FilesService, IFilesService } from '@services/files.service';
import { IPatientsService, PATIENTS_SERVICE, PatientsService } from '@services/patients.service'; // Import the real PatientsService

export function registerServices(container: Container) {
  container.bind(BRACE_ORDERS_SERVICE).to(BraceOrdersService).inSingletonScope();
  container.bind(FILES_SERVICE).to(FilesService).inSingletonScope();
  container.bind(CLIENT_SERVICE).to(ClientService).inSingletonScope();
  container.bind(CLINICS_SERVICE).to(ClinicsService).inSingletonScope();
  container.bind(PATIENTS_SERVICE).to(PatientsService).inSingletonScope();
}

export { PATIENTS_SERVICE, FILES_SERVICE, CLINICS_SERVICE, CLIENT_SERVICE, BRACE_ORDERS_SERVICE };
export type { IPatientsService, IFilesService, IClinicsService, IClientService, IBraceOrdersService };
